(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4232"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4232"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6KuO4", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4e9eef8391115b6c$export$6503ec6e8aabbaf; }, function (v) { return $4e9eef8391115b6c$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4e9eef8391115b6c$export$f7ad0328861e2f03; }, function (v) { return $4e9eef8391115b6c$export$f7ad0328861e2f03 = v; });
var $4e9eef8391115b6c$export$6503ec6e8aabbaf;
var $4e9eef8391115b6c$export$f7ad0328861e2f03;
"use strict";
var $4e9eef8391115b6c$var$mapping = new Map();
function $4e9eef8391115b6c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4e9eef8391115b6c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4e9eef8391115b6c$var$resolve(id) {
    var resolved = $4e9eef8391115b6c$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4e9eef8391115b6c$export$6503ec6e8aabbaf = $4e9eef8391115b6c$var$register;
$4e9eef8391115b6c$export$f7ad0328861e2f03 = $4e9eef8391115b6c$var$resolve;

});

parcelRegister("3LPkI", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2bed948e23b865ba$export$bdfd709ae4826697; }, function (v) { return $2bed948e23b865ba$export$bdfd709ae4826697 = v; });
var $2bed948e23b865ba$export$bdfd709ae4826697;
var $2bed948e23b865ba$export$c9e73fbda7da57b6;
var $2bed948e23b865ba$export$5a759dc7a1cfb72a;
"use strict";
var $2bed948e23b865ba$var$bundleURL = {};
function $2bed948e23b865ba$var$getBundleURLCached(id) {
    var value = $2bed948e23b865ba$var$bundleURL[id];
    if (!value) {
        value = $2bed948e23b865ba$var$getBundleURL();
        $2bed948e23b865ba$var$bundleURL[id] = value;
    }
    return value;
}
function $2bed948e23b865ba$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2bed948e23b865ba$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2bed948e23b865ba$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2bed948e23b865ba$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2bed948e23b865ba$export$bdfd709ae4826697 = $2bed948e23b865ba$var$getBundleURLCached;
$2bed948e23b865ba$export$c9e73fbda7da57b6 = $2bed948e23b865ba$var$getBaseURL;
$2bed948e23b865ba$export$5a759dc7a1cfb72a = $2bed948e23b865ba$var$getOrigin;

});

var $cefc79315e9c8999$exports = {};


(parcelRequire("6KuO4")).register((parcelRequire("3LPkI")).getBundleURL("cD01m"), JSON.parse('["cD01m","index.9824c52e.js","4dLRk","phone-frame.b86bc4f5.svg","jRoPg","app.d3163006.png","bjdy6","logo.2ea790a4.svg","7Ur3N","logo-rtl.1b37b5a5.svg","eToiB","import.3c8459d8.png","ae2Jg","shoppingList.3e3fef12.png","os2k8","steps.8557b918.png","7Iu3Y","web-vitals.d72ae9b4.js"]'));

})();
//# sourceMappingURL=index.runtime.08936a9c.js.map
